import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-composer-empty-state',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="
      ipe:absolute ipe:inset-0
      ipe:flex ipe:items-center ipe:justify-center
      ipe:bg-white
      ipe:z-20
    ">
      <div class="ipe:max-w-md ipe:text-center ipe:px-8">
        <img
          src="/assets/img/logo.svg"
          alt="Visionnaire"
          class="ipe:mx-auto ipe:h-12 ipe:mb-4 ipe:opacity-90"
        />

        <h2 class="ipe:text-lg ipe:font-semibold ipe:text-gray-800 ipe:mb-2">

          {{ 'composition.start' | translate }}
        </h2>

        <p class="ipe:text-sm ipe:text-gray-500 ipe:leading-relaxed">
          {{ 'composition.start_desc_1' | translate }}
          <span class="ipe:font-medium">{{ 'composition.components' | translate }}</span>
          {{ 'composition.start_desc_2' | translate }}
        </p>

        <div class="ipe:mt-5 ipe:inline-flex ipe:items-center ipe:gap-2 ipe:text-sm ipe:text-gray-400">
          {{ 'composition.start_desc_3' | translate }}
        </div>
      </div>
    </div>
  `,
})
export class ComposerEmptyStateComponent {}
